<div class="column">
  <!-- <h1 class="Eurostile-Bol blue">Methods</h1> -->
  <div class="flex-row">
    <app-link *ngFor="let method of methods" [item]="method"></app-link>
  </div>
</div>

